<template>
	<v-dialog v-model="showArrearsData" max-width="1000px" v-if="arrearsData">
		<v-card>
			<v-card-title>
				<span class="headline">Weryfikacja zaległych płatności</span>
			</v-card-title>
			<v-card-text>
				<div class="ma-3">
					<div class="mb-5">
						<strong style="font-size: 16px;">Status:</strong>
						<span class="ml-3"
							style="font-size: 16px;">{{ getTitleByArrearsStatus(arrearsData.status) }}</span>
					</div>
					<div v-for="(arrear, index) in arrearsData.arrears" :key="'arrear-' + index" class="mt-2">
						<div>
							<div>
								<strong style="font-size: 16px;">Tytuł:</strong>
								<span class="ml-3" style="font-size: 16px;">{{ arrear.title }}</span>
							</div>
							<div>
								<strong style="font-size: 16px;">Oferenci:</strong>
								<span class="ml-3" style="font-size: 16px;">
									{{ projectBidders.filter(b => arrear.bidderIds.includes(b.id)).map(b => b.name).join(", ") }}
								</span>
							</div>
						</div>
						<ul class="ml-3">
							<li class="mt-2">
								<div>
									<strong style="font-size: 16px;">Zaległość początkowa:</strong>
									<span v-if="!arrear.init || arrear.init <= 0"
										class="ml-3" style="font-size: 16px;">brak</span>
									<span v-else class="ml-3"
										style="font-size: 16px;">{{formatMoney(arrear.init) + " PLN"}}</span>
								</div>
							</li>
							<li class="mt-2">
								<div>
									<strong style="font-size: 16px;">Zaległość teraźniejsza:</strong>
									<span v-if="!arrear.current || arrear.current <= 0"
										class="ml-3" style="font-size: 16px;">brak</span>
									<span v-else class="ml-3"
										style="font-size: 16px;">{{formatMoney(arrear.current) + " PLN"}}</span>
								</div>
							</li>
						</ul>
					</div>
					<v-layout mt-5><h3>Szczegółowe informacje:</h3></v-layout>
					<div class="ma-3">{{arrearsData.remarks ? arrearsData.remarks : "Brak."}}</div>
				</div>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" @click="showArrearsData = false">Zamknij</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
	import {Numbers} from "@/utils/Numbers";
  import {Project} from "@/api/generated/Project";

	export default {
		name: "ProjectArrearsView",

		mixins: [Numbers],

		data() {
			return {
				showArrearsData: this.isOpen,
        projectBidders: [],
			};
		},

    methods: {
      getBidderAndMutualNames () {
        Project.getBidderAndMutualNames(this, this.arrearsData.projectId, successResponse => {
          this.projectBidders = successResponse;
        }, errorResponse => {
          this.$messagesBus.$emit("error", "Nie udało się załadować oferentów", errorResponse);
        });
      },

			getColorByArrearsStatus (status) {
				switch (status) {
					case "NONE":
						return "green darken-1";
					case "NOT_PAID":
						return "lightred";
					default:
						return "success";
				}
			},

			getTitleByArrearsStatus (status) {
				switch (status) {
					case "NONE":
						return "Brak zaległych płatności";
					case "NOT_PAID":
						return "Zaległe płatności";
					default:
						return "Zaległe płatności uregulowane";
				}
			},
		},

		watch: {
			isOpen: {
				immediate: true,
				handler (val) {
					this.showArrearsData = val;
				},
			},

			showArrearsData: {
				handler (val) {
          if (val) {
            this.getBidderAndMutualNames();
          } else {
            this.$emit("update:isOpen", false);
          }
				}
			}
		},

		props: {
			arrearsData: {type: Object},
			isOpen: {type: Boolean, default: false},
		}
	};
</script>

<style scoped>

</style>